// extracted by mini-css-extract-plugin
export default {"card_text_over_image":"card_text_over-Image_card_text_over_image__VuJm7","overlay_bg":"card_text_over-Image_overlay_bg__OvSl6"};